import cx from 'classnames'

type Props = {
  value: string
}

const ContentStatus = ({ value }: Props) => {
  return (
    <span
      className={cx('px-2 py-1.75 text-2.5 font-medium uppercase rounded-sm', {
        'bg-RAGamber text-base-700': [
          'Draft',
          'Pending Approval',
          'Missing Results',
        ].includes(value),
        'bg-RAGred text-white': value === 'New Language',
        'bg-RAGGreen text-white': value === 'Live',
        'text-base-700': value === 'Completed',
      })}
    >
      {value}
    </span>
  )
}

export default ContentStatus
